import React from "react";
import { Page } from "../activities/AppPage";
import { formatPatientGender } from "../formatUtils";
import { PatientGender, PatientId } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHEVRON_RIGHT_SVG } from "../utils/svgs";
import { USER_ICON } from "../utils/svgs_new";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import { AppListItem } from "./Generic/AppList";
import { isDefined } from "./Generic/IsDefined";

type Props =
  | {
      hasAccessToPatient: false;
      patientName: string;
      patientAge: number | null;
      patientGender: PatientGender | null;
    }
  | {
      hasAccessToPatient: true;
      patientName: string;
      patientAge: number | null;
      patientGender: PatientGender | null;
      patientId: PatientId;
      onRequestNavigate: (page: Page) => void;
    };

export default function PatientInformationAppListItem(props: Props) {
  const patientInformation = [
    props.patientAge !== null
      ? `${props.patientAge} ${translate(STRINGS.YEARS_OLD)}`.toLowerCase()
      : null,
    props.patientGender !== null ? formatPatientGender(props.patientGender).toLowerCase() : null,
  ]
    .filter(isDefined)
    .join(", ");

  const handleClickOpenPatient = () => {
    if (!props.hasAccessToPatient) {
      return;
    }

    return props.onRequestNavigate({ type: "Patient", patientId: props.patientId });
  };

  return (
    <AppListItem
      leading={<AppIcon icon={USER_ICON} fill="primary" />}
      title={props.patientName}
      extra={<AppListItem title={patientInformation} soft={true} />}
      trailing={
        props.hasAccessToPatient ? (
          <AppButton size="small" variant="outline" className="UserDetailsButton">
            {translate(STRINGS.DETAILS)}
            <AppIcon icon={CHEVRON_RIGHT_SVG} size={12} />
          </AppButton>
        ) : undefined
      }
      onClick={handleClickOpenPatient}
    />
  );
}
